
import React from 'react'
import ELearningCourse from '../../../modules/ELearning/Course'

const ELearningCoursePage = () => {
  return <ELearningCourse />
}

export default ELearningCoursePage
